export default function Invoices() {
  return <></>;
}
